import { useTranslation } from "react-i18next";

export function AllowAccessBadge({ allow, allowLabel, denyLabel }) {
   const { t } = useTranslation();
   allowLabel = allowLabel ?? t('common.granted');
   denyLabel = denyLabel ?? t('common.denied');
   if (allow) {
      return (
         <div className="inline-flex h-fit! items-center gap-2! text-green-400 rounded-(--borderRadius)">
            <span className="inline-flex size-1.5! rounded-full bg-green-400"></span>
            <span className="font-semibold!">{allowLabel}</span>
         </div>
      );
   }
   return (
      <div className="inline-flex h-fit! items-center gap-2! text-red-400 rounded-(--borderRadius)">
         <span className="inline-flex size-1.5! rounded-full bg-red-400"></span>
         <span className="font-semibold!">{denyLabel}</span>
      </div>
   );
}